import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const getNotifications = () => axios({
  method: 'get',
  url: config.endpoints.operators.notifications,
  headers: getHeaders(true)
})

const updateNotifications = (data) => axios({
  method: 'post',
  url: config.endpoints.operators.notifications,
  headers: getHeaders(true),
  data
})

export default {
  getNotifications,
  updateNotifications
}
